// One-line summaries of the other three traditions for the first-run reveal.
// All deterministic. For untimed births the Vedic Moon's nakshatra can change
// during the day (the Moon moves ~13°, one nakshatra), so we say so.
import { calculateVedicChart } from "../components/star-charts/vedicMath";
import { calculateChineseChart } from "../lib/astro/chinese";
import { calculateMayanChart } from "../lib/astro/mayan";

const at = (bd, hour, minute, period) => ({ ...bd, hasBirthTime: true, birthTime: { hour, minute, period } });

export function traditionTiles(birthData) {
  const tiles = [];
  try {
    const name = (bd) => calculateVedicChart(bd)?.planets?.moon?.nakshatra?.name;
    let value;
    if (birthData.hasBirthTime) value = name(birthData);
    else {
      // Start, middle and end of the day: the Moon can cross two boundaries
      // in one day, and the middle mansion always holds at noon.
      const opts = [...new Set([name(at(birthData, 12, 0, "AM")), name(at(birthData, 12, 0, "PM")), name(at(birthData, 11, 59, "PM"))].filter(Boolean))];
      value = opts.length > 1 ? `${opts.slice(0, -1).join(", ")} or ${opts[opts.length - 1]}` : opts[0];
    }
    if (value) tiles.push({ key: "vedic", tradition: "Vedic Moon", value, sub: "Moon mansion", term: "nakshatra", accent: "#D4A574" });
  } catch (e) { /* tradition unavailable for this date */ }
  try {
    const c = calculateChineseChart(birthData);
    tiles.push({ key: "chinese", tradition: "Chinese year", value: `${c.element.name} ${c.animal.name}`, sub: "Year animal", term: "chineseZodiac", accent: "#C2625A" });
  } catch (e) { /* unavailable */ }
  try {
    const m = calculateMayanChart(birthData);
    tiles.push({ key: "mayan", tradition: "Maya day", value: `${m.toneIdx + 1} ${m.daySign.name}`, sub: m.daySign.symbol.split(" /")[0], term: "tzolkin", accent: "#6DA88F" });
  } catch (e) { /* unavailable */ }
  return tiles;
}
